import { motion } from "framer-motion";
import { TESTIMONIALS } from "./data";

const ease = [0.16, 1, 0.3, 1];

export const Testimonials = () => (
  <section id="voices" className="relative py-24 md:py-36" data-testid="testimonials">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10">
      <div className="mb-16 max-w-xl">
        <p className="text-xs tracking-[0.22em] uppercase font-semibold text-terra mb-5">Voices</p>
        <h2 className="font-serif text-4xl md:text-6xl leading-[1.02] tracking-tight">
          What partners <span className="italic text-terra">say</span>.
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-t border-l border-ink/15">
        {TESTIMONIALS.map((q, i) => (
          <motion.figure
            key={i}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, ease, delay: i * 0.08 }}
            data-testid={`testimonial-${i}`}
            className="border-r border-b border-ink/15 p-8 md:p-10 hover:bg-sand/50 transition-colors duration-300"
          >
            <span className="font-serif text-6xl text-terra leading-none">"</span>
            <blockquote className="font-serif text-xl md:text-2xl leading-snug mt-2 mb-8">{q.text}</blockquote>
            <figcaption>
              <p className="font-medium">{q.name}</p>
              <p className="text-sm text-ink/55">{q.role}</p>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
